import { put } from "redux-saga/effects";

import {
  fetchAppLogsSuccess,
  fetchAppLogsFailure,
  fetchCFRLogsURLSuccess,
  fetchCFRLogsURLFailure,
  showNotificationWithTimeout
} from "store/actions";
import { appInstance } from "axios-config";
import { decodeHandler, localDownload } from "utils";
import { NOTIFICATIONS } from "consts";

export function* fetchAppLogsStart(action) {
  try {
    const response = yield appInstance.get("/logs/all", {
      params: { clientUUID: action.clientUUID }
    });

    if (response.status === 200) yield put(fetchAppLogsSuccess(response.data));
    else
      yield put(
        fetchAppLogsFailure({ status: response.status, msg: response.data })
      );
  } catch (error) {
    console.log(error);
  }
}

export function* fetchCFRLogsURLStart(action) {
  try {
    const response = yield appInstance.post("logs/cfrLog", action.data, {
      headers: {
        "Content-Type": "text/plain"
      }
    });

    if (response.status === 200) {
      localDownload(decodeHandler(response.data));
      yield put(fetchCFRLogsURLSuccess(action.index));
    } else {
      yield put(fetchCFRLogsURLFailure(action.index));
      yield put(
        showNotificationWithTimeout("slidingPopup", {
          status: "failure",
          msg: NOTIFICATIONS.logs.unableToDownload
        })
      );
    }
  } catch (error) {
    yield put(fetchCFRLogsURLFailure(action.index));
    yield put(
      showNotificationWithTimeout("slidingPopup", {
        status: "failure",
        msg: NOTIFICATIONS.logs.unableToDownload
      })
    );
    console.log(error);
  }
}
